<script lang="ts" setup>
import RoomieDivider from '@lahaus-roomie/roomie/src/components/RoomieDivider/index.vue'

import type { Props } from './types'

defineProps<Props>()
const { t } = useI18n()

</script>

<script lang="ts">

export default {
  name: 'PdBuilderInfo'
}
</script>

<template>
  <section v-if="builderInfo">
    <div class="rounded-16 px-24 py-48 border-carbon-light-300 rounded lg:border">
      <p class="text-brand-800 text-12 font-medium tracking-2">
        {{ t('we_present') }}
      </p>

      <h3 class="text-carbon-800 text-26 font-semibold">
        {{ builderInfo.name }}
      </h3>

      <svg
        class="mt-10"
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="63"
        viewBox="0 0 21 63"
        fill="white">
        <path
          d="M0.5 62.5V2.74329C0.5 0.973664 2.62915 0.0759165 3.8962 1.3113L20.5 17.5"
          stroke="#C2CAC8" />
      </svg>

      <div class="-mt-46 rounded-8 border border-carbon-light-300 ">
        <div class="px-24 pt-24">
          <div>
            <p class="text-16 font-medium text-carbon-600">
              <span class="text-brand-800">
                {{ t('num_years', { n: builderInfo.years_of_experience }) }}
              </span>

              {{ t('building') }}
            </p>

            <RoomieDivider
              class="my-8"
              color="carbon-light-300"
              :rounded="false"
              :vertical="false" />
          </div>

          <p
            class="mb-12 text-16 font-medium text-carbon-600">
            <span class="text-brand-800">
              {{ t('num_projects', { n: builderInfo.number_of_projects_built }) }}
            </span>
            {{ t('delivered') }}
          </p>
        </div>

        <div class="px-24 py-24 text-12 text-carbon-600 bg-brand-50 rounded-md lg:bg-carbon-light-50">
          {{ t('projects_in', {city: projectCity}) }}
        </div>
      </div>
    </div>
  </section>
</template>

<i18n src="./i18n.json" lang="json"></i18n>
